export default __webpack_public_path__ + "static/media/failed_icon.1bb6c506.svg";